// extracted by mini-css-extract-plugin
module.exports = {"main":"TransationsSuccessMain_main__2myeI","head":"TransationsSuccessMain_head__3aPNB","btn":"TransationsSuccessMain_btn__1jSMG","image":"TransationsSuccessMain_image__2H0os"};